import label from "@/lang/StaticLabels.js";

let navItems = [
    {
      to: 'Dashboard',
      label: label.menu.dashboard,
      icon: 'mdi-home',
      active: false,
      subItems: false,
    },
    {
      to: 'About',
      label: label.menu.about,
      icon: 'mdi-information-outline',
      active: false,
      subItems: false,
    },
    {
      to: null,
      label:label.menu.baseInformation,
      icon:'mdi-database',
      active:false,
      subItems:[
        {
          to: 'BaseInformations',
          label: label.menu.baseInformation,
          icon: 'mdi-subdirectory-arrow-left'
        },
        {
          to: 'Profile',
          label: label.menu.editProfile,
          icon: 'mdi-subdirectory-arrow-left'
        },
      ]
    },
    {
      to: 'Users',
      label: label.menu.users,
      icon: 'mdi-account-multiple',
      active: false,
      subItems: false,
    },
    {
      to: null,
      label: label.menu.manageProducts,
      icon: 'mdi-cart-outline',
      active: false,
      subItems:[
        {
          to: 'Products',
          label: label.menu.products,
          icon: 'mdi-subdirectory-arrow-left'
        },
        {
          to: 'AddOrder',
          label: label.menu.addOrder,
          icon: 'mdi-subdirectory-arrow-left'
        },
      ]
    },
    {
      to: 'RejectedTemplate',
      label: label.menu.rejectedTemplate,
      icon: 'mdi-close-box',
      active: false,
      subItems: false,
    },
];

export default navItems;
